import { render, staticRenderFns } from "./BundleValues.vue?vue&type=template&id=580581e2&"
import script from "./BundleValues.vue?vue&type=script&lang=js&"
export * from "./BundleValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports